
import ExitToAppTwoToneIcon from '@mui/icons-material/ExitToAppTwoTone';
import DashboardTwoToneIcon from '@mui/icons-material/DashboardTwoTone';
import { AppRoutes } from '../../../axios/endPoints';
import { handleLogOut } from '../../../store/auth-slice/auth-slice';
import GroupTwoToneIcon from '@mui/icons-material/GroupTwoTone';
import ModelTrainingIcon from '@mui/icons-material/ModelTraining';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export enum Roles 
{
    Admin = "Admin",
    USEPAdmin = "USEPAdmin",
    USEPUser = "USEPUser"
}

export enum USEPRoles {
    USEPAdmin = "USEPAdmin",
    USEPUser = "USEPUser"
}

export const menuItems = (t : Function, dispatch: any, navigate : Function) => [
    {
        title: t('translations:SIDEBAR_ABOUT_TEXT'),
        icon: <InfoOutlinedIcon />,
        onClickFunction: () => {
            navigate(AppRoutes.ABOUT);
        },
        roles: [Roles.Admin, Roles.USEPAdmin, Roles.USEPUser],
        route: AppRoutes.ABOUT
    },
    {
        title: t('translations:SIDEBAR_PREDICTIONS_TEXT'),
        icon: <DashboardTwoToneIcon />,
        onClickFunction: () => {
            navigate(AppRoutes.PREDICTIONS);
        },
        roles: [Roles.Admin, Roles.USEPAdmin, Roles.USEPUser],
        route: AppRoutes.PREDICTIONS
    },
    {
        title: t('translations:SIDEBAR_USER_MANAGEMENT_TEXT'),
        icon: <GroupTwoToneIcon />,
        onClickFunction: () => {
            navigate(AppRoutes.USER_MANAGEMENT);
        },
        roles: [Roles.Admin, Roles.USEPAdmin],
        route: AppRoutes.USER_MANAGEMENT
    },
    {
        title: t('translations:SIDEBAR_MODEL_TRAINING_TEXT'),
        icon: <ModelTrainingIcon />,
        onClickFunction: () => {
            navigate(AppRoutes.MODEL_TRAINING);
        },
        roles: [Roles.Admin, Roles.USEPAdmin],
        route: AppRoutes.MODEL_TRAINING
    },
    {
        title: t('translations:SIDEBAR_LOGOUT_TEXT'),
        icon: <ExitToAppTwoToneIcon />,
        onClickFunction: () => {
            dispatch(handleLogOut());
            navigate(AppRoutes.LOG_IN);
        }
    },
]